module.exports = __webpack_public_path__ + "img/bingo_ball-1.d1dee700.png";